import { SecurityQuestion } from "lib/models/client/LowTaxBroker/SecurityQuestionType";

export const getSecurityQuestionOptions = (t) =>
  Object.values(SecurityQuestion).map((option) => ({
    label: t(`generic:ride-broker-onboarding.security-questions.options.${option}`),
    value: option
  }));
